// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"487":"ca6722fe","686":"ca6722fe","725":"0a25b140","840":"ca6722fe"}[chunkId] + ".chunk.css";
};